import { render, staticRenderFns } from "./CommonReadingComprehension.vue?vue&type=template&id=73236568&scoped=true"
import script from "./CommonReadingComprehension.vue?vue&type=script&lang=js"
export * from "./CommonReadingComprehension.vue?vue&type=script&lang=js"
import style0 from "./CommonReadingComprehension.vue?vue&type=style&index=0&id=73236568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73236568",
  null
  
)

export default component.exports